import React from 'react';
import Services from '../components/Services';

const ServicesPage = () => {
  return (
    <div className="pt-20">
      <Services />
    </div>
  );
};

export default ServicesPage;